<template lang="pug">
    div#breadcrumb
        nav.breadcrumb(aria-label="breadcrumbs")
            ul
                li(v-for="(breadcrumb, idx) in list", :key="idx", @click="route_to(idx)" v-bind:class="is_active(idx)", aria-current="page")
                    a {{breadcrumb.name}}

</template>

<script>
export default {
    name: 'breadcrumbs',

    data: function () {
        return {
            list: []
        };
    },

    mounted: function() {
        this.update_list();
    },

    methods: {
        route_to (idx) {
            if (this.list[idx].link)
                this.$router.push(this.list[idx].link)
        },

        update_list () {
            this.list = this.$route.meta.breadcrumb
        },

        is_active(idx) {
                return {
                    'is-active': !this.list[idx].link,
                    '': this.list[idx].link
                };
            
        }
    },

    watch: {
        '$route' () {
            this.update_list();
        }
    }

}
</script>

<style scoped>
div {
    margin-bottom: 1rem;
}
</style>
